// extracted by mini-css-extract-plugin
export default {"tableManager":"TableCost_tableManager__GJ1R4","tableContainer":"TableCost_tableContainer__4PiAo","scrollBox":"TableCost_scrollBox__pnpBo"};